(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebikebuyer-adventures-hero"] && !Shopify.designMode) return;
  try {
    
function updateAdventureHeroHeight() {
  const main = document.getElementById('MainContent');
  if (!main) return;
  const headerHeight = Math.max(0, Math.round(main.getBoundingClientRect().top + window.scrollY));
  document.querySelectorAll('.ebb-adventures').forEach(hero => {
    hero.style.setProperty('--ebb-header-height', headerHeight + 'px');
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateAdventureHeroHeight, { once: true });
} else {
  updateAdventureHeroHeight();
}
window.addEventListener('resize', updateAdventureHeroHeight, { passive: true });
document.addEventListener('shopify:section:load', updateAdventureHeroHeight);
const adventureHeader = document.querySelector('header');
if (adventureHeader && typeof ResizeObserver !== 'undefined') {
  new ResizeObserver(updateAdventureHeroHeight).observe(adventureHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebikebuyer-gallery-benefits"] && !Shopify.designMode) return;
  try {
    
(() => {

  if (!customElements.get('ebike-mobile-bike-nav')) {
    class EbikeMobileBikeNav extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const details = this.querySelector('details');
        if (!details) return;
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !details.open) return;
          event.preventDefault();
          details.open = false;
          details.querySelector('summary').focus();
        }, { signal });
        document.addEventListener('click', (event) => {
          if (details.open && !details.contains(event.target)) details.open = false;
        }, { signal });
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) details.open = false;
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    }
    customElements.define('ebike-mobile-bike-nav', EbikeMobileBikeNav);
  }

  if (customElements.get('ebike-gallery-carousel')) return;

  class EbikeGalleryCarousel extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('.ebike-gallery-benefits__grid');
      if (!this.track) return;
      this.slides = [...this.track.children].filter((slide) => slide.classList.contains('ebike-gallery-benefits__item'));
      this.dots = [...this.querySelectorAll('[data-ebike-gallery-slide]')];
      if (this.slides.length < 2) return;
      this.mobile = matchMedia('(min-width: 768px) and (max-width: 989px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.current = 0;
      this.classList.add('is-carousel-ready');

      const queueUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      const mediaChange = () => {
        this.track.tabIndex = this.mobile.matches ? 0 : -1;
        if (this.mobile.matches) {
          this.setAttribute('aria-roledescription', this.dataset.carouselDescription);
        } else {
          this.removeAttribute('aria-roledescription');
          this.track.scrollTo({ left: 0, behavior: 'auto' });
        }
        queueUpdate();
      };
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.show(Number(dot.dataset.ebikeGallerySlide)), { signal });
      });
      this.track.addEventListener('scroll', queueUpdate, { passive: true, signal });
      this.track.addEventListener('keydown', (event) => {
        if (!this.mobile.matches || event.target !== this.track) return;
        const indices = {
          ArrowRight: this.current + 1,
          ArrowLeft: this.current - 1,
          Home: 0,
          End: this.slides.length - 1
        };
        if (!(event.key in indices)) return;
        event.preventDefault();
        this.show(indices[event.key]);
      }, { signal });
      this.mobile.addEventListener('change', mediaChange, { signal });
      this.resizeObserver = new ResizeObserver(queueUpdate);
      this.resizeObserver.observe(this.track);
      mediaChange();
    }

    show(index) {
      if (!this.mobile.matches || !Number.isInteger(index)) return;
      const selected = Math.max(0, Math.min(this.slides.length - 1, index));
      const offset = this.slides[selected].offsetLeft - this.slides[0].offsetLeft;
      this.track.scrollTo({
        left: offset,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    update() {
      if (!this.track || !this.slides.length) return;
      const origin = this.slides[0].offsetLeft;
      this.current = this.slides.reduce((best, slide, index) => {
        const distance = Math.abs(slide.offsetLeft - origin - this.track.scrollLeft);
        const previous = Math.abs(this.slides[best].offsetLeft - origin - this.track.scrollLeft);
        return distance < previous ? index : best;
      }, 0);
      this.dots.forEach((dot, index) => {
        if (index === this.current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  }

  customElements.define('ebike-gallery-carousel', EbikeGalleryCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebikebuyer-premium-listing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ebb-listing-preview')) {
    customElements.define('ebb-listing-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.trigger = this.querySelector('[data-listing-open]');
        this.dialog = this.querySelector('dialog');
        if (!this.trigger || !this.dialog) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.trigger.addEventListener('click', () => {
          if (!this.dialog.open) this.dialog.showModal();
        }, options);
        this.querySelector('[data-listing-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        if (this.events) this.events.abort();
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
